/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { CSVLink } from 'react-csv';
import { useSelector, useDispatch } from 'react-redux';
import { getClickCoupons } from '../../../redux/actions/analytics';
import CustomButton from '../../CustomButton';
import LinkButton from '../../LinkButton';
import { formatDate } from '../helper';
import Spinner from '../../Spinner';

const CouponClick = ({ startDate, endDate }) => {
  const dispatch = useDispatch();
  const couponLoading = useSelector((state) => state.analytics.clickcoupon_loading);
  const coupon = useSelector((state) => state.analytics.clickcoupon);

  useEffect(() => {
    if (startDate !== '' && endDate !== '') {
      dispatch(getClickCoupons(formatDate(startDate), formatDate(endDate)));
    }
  }, []);

  const search = () => {
    dispatch(getClickCoupons(formatDate(startDate), formatDate(endDate)));
  };

  const headers = [
    { label: 'Company', key: 'companyname' },
    { label: 'Product', key: 'product' },
    { label: 'Coupon', key: 'title' },
    { label: 'URL', key: 'deal' },
    { label: 'Clicks', key: 'pressed' },
    { label: 'Percentage (views / all views)', key: 'percentage' },
    { label: 'Unique', key: 'unique' },
  ];

  return (
    <div className="w-full flex flex-col items-center">
      <div>
        {couponLoading && <Spinner />}
        {!couponLoading && (
          <div>
            <div className="my-8 flex items-center justify-center w-full">
              <CustomButton type="button" className="text-white" onClick={search}>
                Search
              </CustomButton>

              {coupon.length !== 0 ? (
                <CSVLink
                  className="bg-orange text-white p-2 rounded"
                  filename={`CouponClicks-${formatDate(startDate)}-${formatDate(endDate)}.csv`}
                  data={coupon.screens}
                  headers={headers}
                >
                  Download this table
                </CSVLink>
              ) : null}
            </div>

            {coupon.length !== 0 && (
              <table>
                <thead>
                  <tr>
                    <th>Company</th>
                    <th>Product</th>
                    <th>Coupon</th>
                    <th>URL</th>
                    <th>Clicks</th>
                    <th>Percentage (click / all clicks)</th>
                    <th>Unique</th>
                  </tr>
                </thead>
                <tbody>
                  {coupon.screens.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.companyname.join(', ')}</td>
                        <td>{item.product.join(', ')}</td>
                        <td>{item.title}</td>
                        <td
                          style={{
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                          }}
                        >
                          <LinkButton url={item.deal} />
                          {item.deal}
                        </td>
                        <td>{item.pressed}</td>
                        <td>{((item.pressed / coupon.total) * 100).toFixed(2)}%</td>
                        <td>{item.unique}</td>
                      </tr>
                    );
                  })}
                  <tr className="font-bold">
                    <td>SUM</td>
                    <td />
                    <td />
                    <td />
                    <td>{coupon.total}</td>
                    <td />
                    <td>{coupon.uniq}</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CouponClick;
